import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';

function DisclaimerPage() {
  const [content, setContent] = useState('# Loading Disclaimer…');
  const [error, setError] = useState(null);

  useEffect(() => {
    async function loadMarkdown() {
      try {
        const res = await fetch('/disclaimer.md');
        if (!res.ok) {
          throw new Error(`HTTP error ${res.status}`);
        }
        const text = await res.text();
        setContent(text);
      } catch (err) {
        console.error('Error loading disclaimer.md:', err);
        setError('Unable to load Disclaimers.');
      }
    }
    loadMarkdown();
  }, []);

  return (
    <div className="page">
      {/* Main content */}
      <main>
        <section className="section">
          <div className="container">
            
            <div className="markdown-body" style={{ padding: '1.5rem 0' }}>
              {error ? (
                <p style={{ color: 'red' }}>{error}</p>
              ) : (
                <ReactMarkdown>{content}</ReactMarkdown>
              )}
            </div>
          </div>
        </section>
      </main>

      {/* Footer – same as Privacy for consistency */}
      <footer className="footer">
        <div className="container footer-inner">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            {/* <LogoLockup />  // optional, if you import it here */}
            <strong>CuvrIQ</strong>
            <span>•</span>
            <span>Coverage questions. Intelligent answers.</span>
          </div>
          <div className="footer-links">
            <a href="/privacy">Privacy</a>
            <a href="/terms">Terms</a>
            <a href="/terms">Disclaimer</a>  
            <a href="mailto:pmakadiadds@gmail.com">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default DisclaimerPage;
